module.exports = "<div class=\"grid\">\r\n    <div>\r\n        <semso-pdf-viewer [source]=\"source\" *ngIf=\"formCode\"></semso-pdf-viewer>\r\n    </div>\r\n    <div>\r\n        <router-outlet></router-outlet>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/exam-preparation/assignment-pvb/signing/signing.component.html
// module id = ./src/app/exam-preparation/assignment-pvb/signing/signing.component.html
// module chunks = main